import { sortBySelected } from '@/components/content/Cart/utils';
import { StoreLocatorItem } from '@/components/content/StoreLocator/components/StoreLocatorList/StoreLocatorItem';
import {
	storeLocatorListDynamicSx,
	storeLocatorListSx,
} from '@/components/content/StoreLocator/styles/StoreLocatorList/storeLocatorList';
import { Store } from '@/components/content/StoreLocator/types/storeLocatorTypes';
import stateCitiesData from '@/data/Content/StoreLocator/storeLocatorStateCitiesList.json';
import Box from '@mui/material/Box';
import { FC, useMemo } from 'react';
import { StoreData } from 'shared/custom/types/commonTypes';

export const StoreLocatorList: FC<{
	selectedState: string;
	closeDrawer: () => void;
	handleChangeStoreSelector: (storeData: StoreData) => void;
	selectedStore: string;
	resultSearch: Store[];
}> = ({ selectedState, closeDrawer, handleChangeStoreSelector, selectedStore, resultSearch }) => {
	const cityList = stateCitiesData.formScheduleObject;
	const listStoresByState = useMemo(() => {
		if (resultSearch.length > 0) return resultSearch;
		const state = cityList.find((stores) => stores.stateId === selectedState);
		const list = state?.stores || [];
		const cloned = [...list];
		return sortBySelected(cloned, selectedStore);
	}, [cityList, selectedState, resultSearch]);

	return (
		<Box sx={storeLocatorListSx.container}>
			{listStoresByState.map((store: any) => (
				<Box
					key={store.stLocId}
					sx={storeLocatorListDynamicSx.container(selectedStore === store.stLocId)}
				>
					<StoreLocatorItem
						storeData={store}
						closeDrawer={closeDrawer}
						handleChangeStoreSelector={handleChangeStoreSelector}
						selectedStore={selectedStore}
						showMapLocation
						isStoreLocatorPanel
					/>
				</Box>
			))}
		</Box>
	);
};
